import React from 'react';

const Icon = props => <i {...props} className={`${props.prefix} ${props.prefix}-${props.name} ${props.className}`} />;

Icon.defaultProps = {
  prefix: 'glyph',
};

export default Icon;
